module.exports = __webpack_public_path__ + "static/media/Compras5.da5d3896.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras5.png
// module id = 2071
// module chunks = 0